export const navCopy = {
  skip_to_content: "Pular para o conteúdo principal",
  nav_documentation: "Documentação",
  nav_documentation_short: "Docs",
  nav_download: "Baixar",
  nav_community: "Comunidade",
  nav_playground: "Playground",
  nav_playground_short: "Play",
  nav_handbook: "Manual",
  nav_tools: "Ferramentas",
  nav_search_placeholder: "Pesquise nas Docs",
  nav_search_aria: "Pesquise no site do TypeScript",
  nav_beta: "Pesquise no site do TypeScript",
  nav_beta_notification:
    "Nota: nós estamos testando a versão v2 do site durante esse final de semana, se esquecemos de algo qual você confia, por favor <a>crie uma issue em microsoft/TypeScript-Website</a>.",
  // let me know if you can't make this work in your lang:
  // TypeScript X.Y [stable][between?]Z.Y[beta/rc]
  nav_version_stable_prefix: "está disponível agora",
  nav_version_between: ", ",
  nav_version_beta_prefix: "está atualmente em beta.",
  nav_version_rc_prefix: "tem um candidato a lançamento para testar.",
  nav_this_page_in_your_lang: "Essa página está disponível na sua língua",
  nav_this_page_in_your_lang_open: "Navegar",
  nav_this_page_in_your_lang_no_more: "Não mostra de novo",
}
